import { CurrencyValue } from '../../model/CurrencyValue'

export function getDisplayValue(value?: CurrencyValue, precision?: number) {
  return value ? value.format(precision) : '-'
}
